import { render, staticRenderFns } from "./viewjymxForm.vue?vue&type=template&id=10487c29&scoped=true&"
import script from "./viewjymxForm.vue?vue&type=script&lang=js&"
export * from "./viewjymxForm.vue?vue&type=script&lang=js&"
import style0 from "./viewjymxForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./viewjymxForm.vue?vue&type=style&index=1&id=10487c29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10487c29",
  null
  
)

component.options.__file = "viewjymxForm.vue"
export default component.exports